import { Box } from '@wix/design-system';
import {
  HeaderBanner as StudioLogoBanner,
  STUDIO_STRIP_BG_COLOR,
  useAnonymous,
} from '@wix/package-picker-shared-studio';
import React from 'react';
import WixStudioWordmark from '../../assets/wix-studio-wordmark.svg';
import { PromotionalMessage } from './PromotionalMessage';

export const HeaderBanner = () => {
  const { isAnonymous } = useAnonymous();

  return (
    <Box direction="vertical" width="100%">
      {!isAnonymous && (
        <Box
          height="56px"
          verticalAlign="middle"
          padding="0 SP6"
          boxSizing="border-box"
        >
          <StudioLogoBanner
            shouldShowSwitchPlanBanner
            logo={<WixStudioWordmark />}
          />
        </Box>
      )}
      <Box width="100%" padding="0 SP8" boxSizing="border-box">
        <Box
          width="100%"
          height="46px"
          align="center"
          verticalAlign="middle"
          borderRadius="6px"
          backgroundColor={STUDIO_STRIP_BG_COLOR}
        >
          <PromotionalMessage />
        </Box>
      </Box>
    </Box>
  );
};
